// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1_2DR","addWidgetButton":"Header_addWidgetButton__31-44","dashboardTabs":"Header_dashboardTabs__2gRHy","active":"Header_active__30HCc"};